import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Hashtag} from "../interface/hashtag";
import {CreateHashtagRequest} from "../interface/createHashtagRequest";
import {UpdateHashtagRequest} from "../interface/updateHashtagRequest";


@Injectable({
  providedIn: 'root'
})
export class HashtagService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  createHashtag(hashtag: CreateHashtagRequest): Observable<Hashtag> {
    return this.http.post<Hashtag>(`${this.apiUrl}/hashtags/`, hashtag);
  }

  getHashtags(): Observable<Array<Hashtag>> {
    return this.http.get<Array<Hashtag>>(`${this.apiUrl}/hashtags/`);
  }

  deleteHashtagById(id: number): Observable<string> {
    return this.http.delete(`${this.apiUrl}/hashtags/${id}`, {responseType: 'text'});
  }

  updateHashtag(id: number, hashtagUpdateRequest: UpdateHashtagRequest): Observable<any> {
    return this.http.put(`${this.apiUrl}/hashtags/${id}`, hashtagUpdateRequest);
  }

  getHashtagById(id: number): Observable<Hashtag> {
    return this.http.get<Hashtag>(`${this.apiUrl}/hashtags/${id}`);
  }

  checkHashtagExists(name: string): Observable<boolean> {
    const params = new HttpParams().set('name', name);
    return this.http.get<boolean>(`${this.apiUrl}/hashtags/exists`, {params});
  }

  search(query: string, page: number, size: number): Observable<Hashtag[]> {
    const params = new HttpParams().set('query', query).set('page', page).set('size', size);
    return this.http.get<Hashtag[]>(`${this.apiUrl}/hashtags/search`, {params});
  }

  getTotalHashtagCount(): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/hashtags/count`);
  }
}
